/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-contact2-portlet')) {
  import(/* webpackChunkName: "contact2-portlet" */ './contact2');
}
